import { Link } from "react-router-dom";
import { Instagram, Youtube } from "lucide-react";
import Logo from "./Logo";
import { useEffect, useState } from "react";
import api from "@/lib/api";

export const Footer = () => {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-mp-black">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <Logo size={56} />
            <p className="mt-6 font-display text-3xl md:text-4xl leading-[1.05] tracking-tight max-w-md">
              Entender mejor. <span className="text-mp-orange">Decidir mejor.</span>
            </p>
            <p className="mt-6 text-mp-mute text-sm max-w-md leading-relaxed">
              Un podcast en español para los latinos en Estados Unidos sobre dinero, negocios,
              oportunidades y decisiones que importan.
            </p>
          </div>

          <div>
            <div className="mp-eyebrow mb-5">Navegación</div>
            <ul className="space-y-3 text-sm">
              {[
                ["/", "Inicio"],
                ["/episodios", "Episodios"],
                ["/invitados", "Invitados"],
                ["/elda-medina", "Elda Medina"],
                ["/contacto", "Contacto"],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} data-testid={`footer-link-${label.toLowerCase()}`} className="mp-link-underline text-white/70 hover:text-white">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="mp-eyebrow mb-5">Contacto</div>
            <ul className="space-y-3 text-sm text-white/70">
              {settings?.email && (
                <li>
                  <a data-testid="footer-email" href={`mailto:${settings.email}`} className="mp-link-underline hover:text-white">
                    {settings.email}
                  </a>
                </li>
              )}
              {settings?.phone && <li data-testid="footer-phone">{settings.phone}</li>}
              <li className="pt-3 flex gap-5">
                {settings?.instagram && (
                  <a href={settings.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="text-white/70 hover:text-mp-orange transition-colors duration-300">
                    <Instagram size={18} />
                  </a>
                )}
                {settings?.youtube && (
                  <a href={settings.youtube} target="_blank" rel="noreferrer" data-testid="footer-youtube" aria-label="YouTube" className="text-white/70 hover:text-mp-orange transition-colors duration-300">
                    <Youtube size={18} />
                  </a>
                )}
                {settings?.tiktok && (
                  <a href={settings.tiktok} target="_blank" rel="noreferrer" data-testid="footer-tiktok" aria-label="TikTok" className="text-white/70 hover:text-mp-orange transition-colors duration-300 font-display text-xs tracking-widest">
                    TIKTOK
                  </a>
                )}
                {settings && !settings.spotify && (
                  <span data-testid="footer-spotify-soon" className="text-mp-dim text-xs tracking-widest font-display uppercase self-center">Spotify: Próx.</span>
                )}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-mp-dim tracking-widest uppercase">© 2026 Modo Pro</p>
          <p className="text-xs text-mp-dim tracking-widest uppercase">South Florida — Español</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
